import { FC } from 'react';
import { Col } from 'antd';
import Main from 'src/common/components/business/DynamicComponent/components/AIPredictEntryRate/Main';

/**
 * 动态表单详情-AI预测进店率
 * @description
 * @demo
 */
const Component:FC<{
  label: string;
  textValue: any;
}> = ({ textValue }) => {

  /* state */

  /* hooks */

  /* methods */

  return <>
    {/* {textValue && Object.keys(textValue).length > 0 && (
      <Col span={24} className={'mt-10'}>
        <Main data={textValue}/>
      </Col>
    )} */}
    <Col span={24} className={'mt-10'}>
      <Main data={textValue}/>
    </Col>
  </>;
};

export default Component;
